import React, { useState } from 'react';
import { Components } from '../../../../utils/types';
import { ReviewSprintSelectionPage } from './ReviewSprintSelectionPage';
import { SprintReviewPage } from './SprintReviewPage';

export const SprintReviewFrame = () => {
    const [selectedSprint, setSelectedSprint] = useState<Components.Schemas.WBSElementDeltaDTO>();

    return !selectedSprint ? (
        <ReviewSprintSelectionPage setSelectedSprint={setSelectedSprint} />
    ) : (
        <SprintReviewPage setSelectedSprint={setSelectedSprint} selectedSprint={selectedSprint} />
    );
};
